module.exports = __webpack_public_path__ + "static/media/b2tbg.1a77e639.jpg";